<template>
  <div id="app">
    <v-app>
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
/* すべての要素で大文字の強制を解除 */
* {
  text-transform: none;
}

/* ゴシック体 */
#app {
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  td,
  dd,
  a,
  span,
  div {
    font-family: 'Roboto', 'STIX Two Text''Helvetica Neue', 'Helvetica', 'Noto Sans JP', 'Noto Serif JP'"Hiragino Sans", "Hiragino Kaku Gothic ProN", "Arial", 'Meiryo', sans-serif !important;
  }
}


/* 明朝体 
#app {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  td,
  dd,
  a,
  span,
  div {
    font-family: 'STIX Two Text', 'Noto Serif JP', "Arial", 'Meiryo', serif !important;
  }

} */

body {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  color: #fff;
  font-family: "Noto Sans JP", sans-serif;
  letter-spacing: 1px;
  position: relative;
}

h3 {
  position: relative;
  padding-left: 1.5em;
}
h3::before {
  position: absolute;
  content: '';
  width: 1em;
  height: 2px;
  background: #fff;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

p a {
  color: rgba(var(--v-theme-primary), 1)!important;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

main.v-main {
    padding-top: 0 !important;
}
</style>
